    // Main Mini Cart initialization and event handlers


    let myInterval;

    const RESERVE_TIMER_DURATION = 10 * 60 * 1000; // 10 minutes
    const RESERVE_TIMER_STORAGE_KEY = 'firstdayCartReserveExpiry';
    let reserveTimerIntervalId = null;

    function storageIsAvailable() {
        if (typeof Storage === 'undefined') {
            return false;
        }

        try {
            const testKey = '__firstday_cart_timer_test__';
            localStorage.setItem(testKey, testKey);
            localStorage.removeItem(testKey);
            return true;
        } catch (error) {
            console.warn('Mini cart: localStorage unavailable', error);
            return false;
        }
    }

    const STORAGE_AVAILABLE = storageIsAvailable();

    function getReserveExpiryFromStorage() {
        if (!STORAGE_AVAILABLE) {
            return null;
        }

        const storedValue = localStorage.getItem(RESERVE_TIMER_STORAGE_KEY);
        if (!storedValue) {
            return null;
        }

        const parsed = parseInt(storedValue, 10);
        return Number.isFinite(parsed) ? parsed : null;
    }

    function setReserveExpiryInStorage(timestamp) {
        if (!STORAGE_AVAILABLE) {
            return;
        }

        localStorage.setItem(RESERVE_TIMER_STORAGE_KEY, String(timestamp));
    }

    function clearReserveExpiryInStorage() {
        if (!STORAGE_AVAILABLE) {
            return;
        }

        localStorage.removeItem(RESERVE_TIMER_STORAGE_KEY);
    }

    function updateReserveCountdownDisplay(expiryTimestamp) {
        const cartTitleElements = document.querySelectorAll('.cart-reserve-duration');
        if (cartTitleElements.length === 0) {
            return;
        }

        const remaining = Math.max(0, expiryTimestamp - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        const formatted = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

        cartTitleElements.forEach(element => {
            element.textContent = `YOUR CART IS RESERVED FOR ${formatted}`;
        });

        if (remaining <= 0) {
            stopReserveCountdown({ resetStorage: true, resetTitle: false });
            cartTitleElements.forEach(element => {
                element.textContent = 'YOUR CART IS RESERVED FOR 00:00';
            });
        }
    }

    function startReserveCountdown(expiryTimestamp) {
        stopReserveCountdown({ resetTitle: false });
        updateReserveCountdownDisplay(expiryTimestamp);
        reserveTimerIntervalId = window.setInterval(() => {
            updateReserveCountdownDisplay(expiryTimestamp);
        }, 1000);
    }

    function stopReserveCountdown(options = {}) {
        const { resetStorage = false, resetTitle = true } = options;

        if (reserveTimerIntervalId) {
            clearInterval(reserveTimerIntervalId);
            reserveTimerIntervalId = null;
        }

        if (resetStorage) {
            clearReserveExpiryInStorage();
        }

        if (resetTitle) {
            const titleElements = document.querySelectorAll('.cart-reserve-duration');
            titleElements.forEach(element => {
                if (element && typeof element.textContent === 'string' && element.textContent.toUpperCase().includes('YOUR CART IS RESERVED')) {
                    // Read the merchant-configured title from data-base-title (set on the cart drawer's h2).
                    element.textContent = element.dataset.baseTitle || 'Your Cart';
                }
            });
        }
    }

    function syncReserveTimerFromStorage() {
        const expiry = getReserveExpiryFromStorage();

        if (expiry) {
            startReserveCountdown(expiry);
        } else {
            stopReserveCountdown({ resetStorage: false, resetTitle: true });
        }
    }

    function handleCartReserveTimer(cartCount) {
        if (!STORAGE_AVAILABLE) {
            return;
        }

        if (cartCount > 0) {
            const now = Date.now();
            let expiry = getReserveExpiryFromStorage();

            if (!expiry || expiry <= now) {
                expiry = now + RESERVE_TIMER_DURATION;
                setReserveExpiryInStorage(expiry);
            }

            startReserveCountdown(expiry);
        } else {
            stopReserveCountdown({ resetStorage: true, resetTitle: true });
        }
    }

    window.handleCartReserveTimer = handleCartReserveTimer;
    window.syncReserveTimerFromStorage = syncReserveTimerFromStorage;

    if (STORAGE_AVAILABLE) {
        window.addEventListener('storage', function (event) {
            if (event.key === RESERVE_TIMER_STORAGE_KEY) {
                syncReserveTimerFromStorage();
            }
        });

        syncReserveTimerFromStorage();
    }

    // Initialize cart when page loads (badge only; full render deferred)
    document.addEventListener('DOMContentLoaded', function () {
        initializeCart();
        setupEventListeners();

        // Check for cart updates periodically
        if (typeof Storage !== "undefined") {
            checkLocalStorage(false);
        }
    });

    let cartInitialized = false;
    const INITIAL_CART_COUNT = window.FDMinicartMainConfig.initialCartCount;

    function lineLooksLikeGift(item) {
        const props = (item && item.properties) || {};
        const truthy = function (value) { return value === true || value === 'true'; };
        if (truthy(props._bundle_gift) || truthy(props._free_gift) || truthy(props._box_picker_gift) || truthy(props._welcome_kit_gift) || truthy(props._quantity_welcome_gift)) return true;
        if (props._upsell_module === 'checkout_gwp') return true;
        if (String((item && item.product_type) || '').toLowerCase() === 'gift') return true;
        return false;
    }

    function displayCartBadgeCount(cart, fallbackCount) {
        const items = cart && Array.isArray(cart.items) ? cart.items : null;
        if (!items) return Number(fallbackCount) || 0;
        const paidQty = items.reduce(function (sum, item) {
            return sum + (lineLooksLikeGift(item) ? 0 : (Number(item.quantity) || 0));
        }, 0);
        if (!paidQty) return 0;
        return Number(cart.item_count) || paidQty;
    }

    // Fetch cart data and update the UI (deduped via FDCartApi)
    function fetchAndRenderCart(force, firstRender) {
        const read = window.FDCartApi
            ? window.FDCartApi.getCart(!!force)
            : fetch('/cart.js').then(response => response.json()).then(cart => {
                if (window.FDCart) window.FDCart.setCart(cart);
                return cart;
            });
        return read.then(function (cart) {
            // An add flow that began meanwhile paints the new cart itself.
            if (firstRender && firstRenderNotNeeded()) return cart;
            updateCartDisplay(cart);
            updateCartCount(displayCartBadgeCount(cart, cart.item_count));
            cartInitialized = true;
            return cart;
        });
    }

    // A flow already painted the cart, or holds the first render while it paints the new cart.
    function firstRenderNotNeeded() {
        if (typeof latestCartState !== 'undefined' && latestCartState) return true;
        const hold = window.__fdCartRenderHold;
        return Boolean(hold && Date.now() < hold.until);
    }


    function initializeCart() {
        updateCartCount(INITIAL_CART_COUNT);

        if (INITIAL_CART_COUNT > 0) {
            var deferredRender = function () {
                if (cartInitialized || firstRenderNotNeeded()) {
                    return;
                }
                fetchAndRenderCart(false, true).catch(function (err) {
                    console.error('Error initializing cart:', err);
                });
            };
            if (typeof window.requestIdleCallback === 'function') {
                window.requestIdleCallback(deferredRender, { timeout: 1500 });
            } else {
                setTimeout(deferredRender, 300);
            }
        }
    }

    function ensureCartRenderedIfNeeded() {
        // Any paint (an add flow paints the cart it confirmed) counts as the first render.
        if (cartInitialized || (typeof latestCartState !== 'undefined' && latestCartState)) {
            return Promise.resolve(window.FDCart ? window.FDCart.getCart() : null);
        }
        // A flow that opens the drawer and paints the new cart itself (bundle builder
        // Shop Now, page adds) skips this first render of the old cart: it competes with
        // the add for the network and could land on top of the new cart. Expires on its own.
        if (firstRenderNotNeeded()) return Promise.resolve(null);
        return fetchAndRenderCart(true, true);
    }

    window.ensureCartRenderedIfNeeded = ensureCartRenderedIfNeeded;

    function refreshMiniCartFromApi() {
        return fetchAndRenderCart().catch(error => {
            console.error('Error refreshing cart:', error);
            throw error;
        });
    }

    window.refreshMiniCartFromApi = refreshMiniCartFromApi;

    // Set up event listeners
    function setupEventListeners() {
        // Cart toggle is already handled in fd-cart-minicart-core.js
        // No need to add duplicate event listener

        // Checkout button listeners
        const buyButtons = document.querySelectorAll('.firstBuyButton, .secondBuyButton');
        buyButtons.forEach(button => {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                addToCartFromProduct();
            });
        });

        // Remove item event delegation
        document.addEventListener('click', function (e) {
            if (e.target.closest('.remove-item')) {
                e.preventDefault();
                const key = e.target.closest('.remove-item').dataset.key;
                removeItem(key);
            }
        });
    }

    // Add product to cart from product page
    async function addToCartFromProduct() {
        const variantSelector = document.querySelector('.variantSelector, [name="id"]');
        const quantitySelector = document.querySelector('[name="quantity"]');
        const subscriptionCheckbox = document.querySelector('#product_subsave-1');

        const variantId = variantSelector ? variantSelector.value : null;
        const quantity = quantitySelector ? parseInt(quantitySelector.value) : 1;
        const isSubscription = subscriptionCheckbox ? subscriptionCheckbox.checked : false;

        if (!variantId) {
            console.error('No variant selected');
            return;
        }

        const formData = {
            items: [{
                id: variantId,
                quantity: quantity
            }]
        };

        // Add selling plan if subscription is selected
        if (isSubscription) {
            formData.items[0].selling_plan = 3896967266; // Default subscription plan
        }

        const pageAdd = window.FDCartPageAdd ? window.FDCartPageAdd.begin([]) : null;
        try {
            const response = await window.addToCart(formData);
            await response.json();
            if (!response.ok) throw new Error('Add to cart failed');

            const updatedCart = window.FDCartApi
                ? await window.FDCartApi.getCart(true)
                : await fetch('/cart.js').then(function (res) { return res.json(); });

            cartInitialized = true;

            if (pageAdd) await pageAdd.confirm(updatedCart);
            else updateCartDisplay(updatedCart);
            updateCartCount(displayCartBadgeCount(updatedCart, updatedCart.item_count));

            showAddToCartMessage('Product added to cart!');
        } catch (error) {
            console.error('Error adding to cart:', error);
            if (pageAdd) pageAdd.fail(error);
            showAddToCartMessage('Error adding product to cart', 'error');
        }
    }

    // Update cart count in header
    function updateCartCount(count) {
        const liveCart = window.FDCart && typeof window.FDCart.getCart === 'function'
            ? window.FDCart.getCart()
            : (typeof latestCartState !== 'undefined' ? latestCartState : null);
        if (liveCart && Array.isArray(liveCart.items)) {
            count = displayCartBadgeCount(liveCart, count);
        }
        const cartCountElements = document.querySelectorAll('.cart-count, #cartCount');
        cartCountElements.forEach(element => {
            element.textContent = count;
        });

        // Update pulse bubble and cart bubble visibility and count
        const pulseBubble = document.querySelector('.pulse-cart-bubble');
        const cartBubble = document.querySelector('.cart-count-bubble');
        const pulseCountElement = document.querySelector('.pulse-cart-bubble-number-of-items');
        const cartCountElement = document.querySelector('.cart-bubble-number-of-items');

        if (count > 0) {
            // Show pulse bubble and hide regular cart bubble when there are items
            if (pulseBubble) {
                pulseBubble.style.display = 'flex';
            }
            if (cartBubble) {
                cartBubble.style.display = 'none';
            }
            // Update count in pulse bubble
            if (pulseCountElement) {
                pulseCountElement.textContent = count;
            }
        } else {
            // Hide both bubbles when cart is empty
            if (pulseBubble) {
                pulseBubble.style.display = 'none';
            }
            if (cartBubble) {
                cartBubble.style.display = 'none';
            }
        }

        // Always update the count in regular cart bubble for consistency
        if (cartCountElement) {
            cartCountElement.textContent = count;
        }
    }

    // Show add to cart message
    function showAddToCartMessage(message, type = 'success') {
        // Create or update message element
        let messageEl = document.querySelector('.add-to-cart-message');
        // if (!messageEl) {
        //     messageEl = document.createElement('div');
        //     messageEl.className = 'add-to-cart-message';
        //     document.body.appendChild(messageEl);
        // }

        // messageEl.textContent = message;
        // messageEl.className = `add-to-cart-message ${type} show`;
        //
        // // Hide message after 3 seconds
        // setTimeout(() => {
        //     messageEl.classList.remove('show');
        // }, 3000);
    }

    // Check local storage for cart updates (simplified version)
    function checkLocalStorage(bypassCheck) {
        if (bypassCheck || !localStorage.getItem('cartLastUpdated')) {
            localStorage.setItem('cartLastUpdated', Date.now());
            return;
        }

        const lastUpdate = parseInt(localStorage.getItem('cartLastUpdated'));
        const timeDiff = Date.now() - lastUpdate;

        // Check for updates every 30 seconds
        if (timeDiff > 30000) {
            fetchAndRenderCart()
                .then(() => {
                    localStorage.setItem('cartLastUpdated', Date.now());
                })
                .catch(error => {
                    console.error('Error checking cart updates:', error);
                });
        }
    }

    // Start countdown timer (simplified)
    function startCountDown() {
        const countdownElements = document.querySelectorAll('.countdown-timer');
        if (countdownElements.length === 0) return;

        const endTime = Date.now() + (24 * 60 * 60 * 1000); // 24 hours from now

        myInterval = setInterval(() => {
            const now = Date.now();
            const timeLeft = endTime - now;

            if (timeLeft <= 0) {
                clearInterval(myInterval);
                countdownElements.forEach(el => {
                    el.textContent = "Offer expired";
                });
                return;
            }

            const hours = Math.floor(timeLeft / (1000 * 60 * 60));
            const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

            const displayTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

            countdownElements.forEach(el => {
                el.textContent = displayTime;
            });
        }, 1000);
    }

    // Utility function to generate random ID
    function makeId(length = 8) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    }

    // Convert milliseconds to minutes and seconds
    function millisToMinutesAndSeconds(millis) {
        const minutes = Math.floor(millis / 60000);
        const seconds = ((millis % 60000) / 1000).toFixed(0);
        return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
    }

    function copyCartLinePropertiesForChange(properties) {
        const next = {};
        if (!properties || typeof properties !== 'object') return next;
        Object.keys(properties).forEach(function (key) {
            const value = properties[key];
            if (value === null || value === undefined) return;
            next[key] = value;
        });
        return next;
    }

    function getLineSellingPlanIdForChange(item) {
        if (!item) return '';
        const allocationPlan = item.selling_plan_allocation &&
            item.selling_plan_allocation.selling_plan &&
            item.selling_plan_allocation.selling_plan.id;
        return String(item.selling_plan || allocationPlan || '').trim();
    }

    function collectCartDiscountCodes(cart) {
        const codes = [];
        const seen = Object.create(null);
        if (!cart || !Array.isArray(cart.discount_codes)) return codes;
        cart.discount_codes.forEach(function (entry) {
            const code = String((entry && entry.code) || '').trim();
            if (!code) return;
            const key = code.toUpperCase();
            if (seen[key]) return;
            seen[key] = true;
            codes.push(code);
        });
        return codes;
    }

    function replaceCartDiscountCode(codes, fromCode, toCode) {
        const next = [];
        const seen = Object.create(null);
        const fromKey = String(fromCode || '').trim().toUpperCase();
        const toNorm = String(toCode || '').trim();
        (codes || []).forEach(function (code) {
            let swapped = String(code || '').trim();
            if (!swapped) return;
            if (fromKey && swapped.toUpperCase() === fromKey && toNorm) {
                swapped = toNorm;
            }
            const key = swapped.toUpperCase();
            if (seen[key]) return;
            seen[key] = true;
            next.push(swapped);
        });
        if (toNorm && !seen[toNorm.toUpperCase()]) next.push(toNorm);
        return next;
    }

    function parsePlanUpgradePercent(raw) {
        const parsed = parseInt(raw, 10);
        if (Number.isFinite(parsed) && parsed > 0 && parsed < 100) return String(parsed);
        return '';
    }

    // Native 90-day ATC uses buy-box block_qty=3 (2 monthly bottles → 6 every 90 days).
    const PLAN_UPGRADE_QTY_MULTIPLIER = 3;

    function parsePositiveQty(raw, fallback) {
        const parsed = parseInt(raw, 10);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
    }

    function applyPlanUpgradeQuantity(properties, action, currentQty) {
        const qty = parsePositiveQty(currentQty, 1);
        if (action === 'undo') {
            const fromQty = parsePositiveQty(properties._plan_upgrade_from_qty, 0);
            const restoreStep = String(properties._plan_upgrade_from_qty_per_change || '').trim();
            delete properties._plan_upgrade_from_qty;
            delete properties._plan_upgrade_from_qty_per_change;
            if (restoreStep) properties._qtyPerChange = restoreStep;
            else delete properties._qtyPerChange;
            if (fromQty && qty === fromQty * PLAN_UPGRADE_QTY_MULTIPLIER) return fromQty;
            return Math.max(1, Math.round(qty / PLAN_UPGRADE_QTY_MULTIPLIER));
        }
        properties._plan_upgrade_from_qty = String(qty);
        const currentStep = String(properties._qtyPerChange || '').trim();
        if (currentStep) properties._plan_upgrade_from_qty_per_change = currentStep;
        else delete properties._plan_upgrade_from_qty_per_change;
        properties._qtyPerChange = String(PLAN_UPGRADE_QTY_MULTIPLIER);
        return qty * PLAN_UPGRADE_QTY_MULTIPLIER;
    }

    function cartHasOtherUpgradedLines(cart, exceptKey) {
        if (!cart || !Array.isArray(cart.items)) return false;
        return cart.items.some(function (item) {
            if (!item || item.key === exceptKey) return false;
            return String((item.properties && item.properties._plan_switcher_from) || '').trim() !== '';
        });
    }

    async function resolveQuarterlySellingPlanId(item) {
        const handle = item && item.handle;
        if (!handle) return '';
        try {
            const response = await fetch('/products/' + encodeURIComponent(handle) + '.js');
            if (!response.ok) throw new Error('Product fetch failed');
            const product = await response.json();
            const plans = [];
            (product.selling_plan_groups || []).forEach(function (group) {
                (group.selling_plans || []).forEach(function (plan) {
                    plans.push(plan);
                });
            });
            const quarterly = plans.find(function (plan) {
                return /90|quarter/i.test(String(plan.name || ''));
            });
            if (!quarterly) return '';
            const variantId = item.variant_id || item.id;
            if (variantId) {
                const variant = (product.variants || []).find(function (row) {
                    return String(row.id) === String(variantId);
                });
                const allocated = !variant || (variant.selling_plan_allocations || []).some(function (row) {
                    return String(row.selling_plan_id) === String(quarterly.id);
                });
                if (!allocated) return '';
            }
            return String(quarterly.id);
        } catch (error) {
            console.warn('Mini cart: failed to resolve 90-day selling plan', error);
            return '';
        }
    }

    function isSellingPlanRejected(error) {
        const status = error && error.status;
        const text = String((error && (error.message || (error.data && (error.data.description || error.data.message)))) || '').toLowerCase();
        return status === 422 || text.indexOf('selling plan') !== -1;
    }

    function sameDiscountCodes(a, b) {
        const keys = function (list) {
            return (list || []).map(function (code) { return String(code).trim().toUpperCase(); }).sort().join('|');
        };
        return keys(a) === keys(b);
    }

    function planUpgradeNeedsDiscountWrite(cart, fromCode, toCode) {
        const nextCode = String(toCode || '').trim();
        const prevCode = String(fromCode || '').trim();
        if (!nextCode || (prevCode && prevCode.toUpperCase() === nextCode.toUpperCase())) return false;
        const currentCodes = collectCartDiscountCodes(cart);
        return !sameDiscountCodes(currentCodes, replaceCartDiscountCode(currentCodes, prevCode, nextCode));
    }

    async function applyPlanUpgradeDiscountCodes(cart, fromCode, toCode) {
        const nextCode = String(toCode || '').trim();
        const prevCode = String(fromCode || '').trim();
        if (!nextCode) return cart;
        if (prevCode && prevCode.toUpperCase() === nextCode.toUpperCase()) return cart;
        if (!window.FDCartApi || typeof window.FDCartApi.applyDiscounts !== 'function') return cart;
        const currentCodes = collectCartDiscountCodes(cart);
        const nextCodes = replaceCartDiscountCode(currentCodes, prevCode, nextCode);
        if (sameDiscountCodes(currentCodes, nextCodes)) return cart;
        try {
            return await window.FDCartApi.applyDiscounts(nextCodes);
        } catch (discountError) {
            console.error('Error applying plan upgrade discount:', discountError);
            return cart;
        }
    }

    // One line to its 90-day plan or back; target is what the 90-day card resolved (plan, %, whether to restore codes).
    async function planUpgradeLineChange(cartData, matchingItem, action, target) {
        const properties = copyCartLinePropertiesForChange(matchingItem.properties);
        const currentPlanId = getLineSellingPlanIdForChange(matchingItem);
        const currentSubCode = String(properties._sub_discount_code || '').trim();
        const upgradeCode = String(properties._plan_upgrade_code || '').trim();
        const currentSubPct = String(properties._sub_discount_percentage || '').trim();
        const upgradePct = parsePlanUpgradePercent(properties._plan_upgrade_discount_percentage) ||
            parsePlanUpgradePercent(target && target.percent);
        let nextPlanId = '';
        let discountFromCode = '';
        let discountToCode = '';

        if (action === 'undo') {
            nextPlanId = String(properties._plan_switcher_from || '').trim();
            delete properties._plan_switcher_from;
            delete properties._plan_upgrade_source;
            const restoreCode = String(properties._plan_upgrade_from_code || '').trim();
            const keepCode = target ? target.keepCode : cartHasOtherUpgradedLines(cartData, matchingItem.key);
            if (!keepCode) {
                discountFromCode = currentSubCode;
                discountToCode = restoreCode;
            }
            if (Object.prototype.hasOwnProperty.call(properties, '_plan_upgrade_from_code')) {
                if (restoreCode) properties._sub_discount_code = restoreCode;
                else delete properties._sub_discount_code;
                delete properties._plan_upgrade_from_code;
            }
            if (Object.prototype.hasOwnProperty.call(properties, '_plan_upgrade_from_percentage')) {
                const restorePct = String(properties._plan_upgrade_from_percentage || '').trim();
                if (restorePct) properties._sub_discount_percentage = restorePct;
                else delete properties._sub_discount_percentage;
                delete properties._plan_upgrade_from_percentage;
            }
        } else {
            nextPlanId = String((target && target.planId) || properties._plan_upgrade_to || '').trim();
            if (currentPlanId) {
                properties._plan_switcher_from = currentPlanId;
            }
            properties._plan_upgrade_source = 'cart';
            if (upgradeCode) {
                properties._plan_upgrade_from_code = currentSubCode;
                properties._sub_discount_code = upgradeCode;
                discountFromCode = currentSubCode;
                discountToCode = upgradeCode;
            }
            if (upgradePct) {
                properties._plan_upgrade_from_percentage = currentSubPct;
                properties._sub_discount_percentage = upgradePct;
            }
        }

        if (!nextPlanId && action !== 'undo') {
            nextPlanId = await resolveQuarterlySellingPlanId(matchingItem);
            if (nextPlanId) properties._plan_upgrade_to = nextPlanId;
        }

        if (!nextPlanId) {
            throw new Error('Missing target selling plan');
        }

        const currentQty = Number(matchingItem.quantity);
        if (!Number.isFinite(currentQty) || currentQty < 1) {
            throw new Error('Missing line quantity');
        }
        const quantity = applyPlanUpgradeQuantity(properties, action, currentQty);
        return {
            properties: properties,
            nextPlanId: nextPlanId,
            quantity: quantity,
            discountFromCode: discountFromCode,
            discountToCode: discountToCode
        };
    }

    async function changePlanLine(itemKey, quantity, planId, properties) {
        if (window.FDCartApi && typeof window.FDCartApi.changeLine === 'function') {
            return window.FDCartApi.changeLine(itemKey, quantity, {
                selling_plan: planId,
                properties: properties
            });
        }
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: itemKey,
                quantity: quantity,
                selling_plan: planId,
                properties: properties
            })
        });
        const cart = await response.json();
        if (!response.ok) {
            const err = new Error(cart.description || cart.message || 'Cart Error');
            err.status = response.status;
            err.data = cart;
            throw err;
        }
        if (window.FDCart) window.FDCart.setCart(cart);
        return cart;
    }

    // A rejected stamped plan falls back to the product's 90-day plan; the card's own plan has no fallback.
    async function writePlanUpgradeLine(matchingItem, action, change, target) {
        try {
            return await changePlanLine(matchingItem.key, change.quantity, change.nextPlanId, change.properties);
        } catch (planError) {
            if (action === 'undo' || target || !isSellingPlanRejected(planError)) throw planError;
            const fallbackPlanId = await resolveQuarterlySellingPlanId(matchingItem);
            if (!fallbackPlanId || fallbackPlanId === change.nextPlanId) throw planError;
            change.properties._plan_upgrade_to = fallbackPlanId;
            return changePlanLine(matchingItem.key, change.quantity, fallbackPlanId, change.properties);
        }
    }

    async function changePlanUpgrade(itemKey, action) {
        const button = (typeof event !== 'undefined' && event && event.target)
            ? event.target.closest('button')
            : null;
        // The pill goes at once; the line price and the totals wait for the server.
        // The line stays inert until then.
        const pill = button && button.closest('.firstday-cart__plan-upgrade');
        const pillLook = function (article) {
            if (pill) {
                article.querySelectorAll('.firstday-cart__plan-upgrade').forEach(function (el) {
                    el.style.display = 'none';
                });
            }
            if (typeof markLinePricesPending === 'function') markLinePricesPending([article]);
        };
        const releaseLine = typeof holdLine === 'function' ? holdLine(itemKey, pillLook) : function () {};
        if (typeof holdLine !== 'function') {
            if (pill) pill.style.display = 'none';
            const article = button && button.closest('[data-remove-key]');
            if (article && typeof markLinePricesPending === 'function') markLinePricesPending([article]);
        }
        let writeOpen = typeof beginCartWrite === 'function';
        if (writeOpen) beginCartWrite();
        const closeWrite = function () {
            if (writeOpen) endCartWrite();
            writeOpen = false;
        };
        let resolveAction = null;
        let rejectAction = null;
        if (typeof trackDrawerAction === 'function') {
            trackDrawerAction(new Promise(function (resolve, reject) {
                resolveAction = resolve;
                rejectAction = reject;
            })).catch(function () {});
        }

        // Runs after the quantity writes already on their way, so it sends the
        // quantity the drawer shows.
        const task = async function () {
            const cartData = window.FDCart && window.FDCart.getCart()
                ? window.FDCart.getCart()
                : await (window.FDCartApi
                    ? window.FDCartApi.getCart(false)
                    : fetch('/cart.js').then(function (res) { return res.json(); }));
            const matchingItem = cartData && Array.isArray(cartData.items)
                ? cartData.items.find(function (item) { return item.key === itemKey; })
                : null;
            if (!matchingItem) {
                throw new Error('Cart line not found');
            }

            const change = await planUpgradeLineChange(cartData, matchingItem, action);
            const discountFromCode = change.discountFromCode;
            const discountToCode = change.discountToCode;
            let updatedCart = await writePlanUpgradeLine(matchingItem, action, change);

            // Show the new plan now; the code swap is one more write.
            if (planUpgradeNeedsDiscountWrite(updatedCart, discountFromCode, discountToCode) && typeof updateCartDisplay === 'function') {
                await updateCartDisplay(updatedCart, {
                    skipDiscountPrune: true,
                    skipPlanUpgradeBackfill: true,
                    skipGwpSync: true,
                    skipRecommendations: true
                });
                if (typeof markAllLinePricesPending === 'function') markAllLinePricesPending();
                updatedCart = await applyPlanUpgradeDiscountCodes(
                    updatedCart,
                    discountFromCode,
                    discountToCode
                );
            }

            closeWrite();
            releaseLine();
            if (typeof updateCartDisplay === 'function') {
                await updateCartDisplay(updatedCart);
            }
            if (resolveAction) resolveAction();
            if (typeof window.announceToScreenReader === 'function') {
                const productTitle = matchingItem.product_title || 'Item';
                window.announceToScreenReader(
                    action === 'undo'
                        ? productTitle + ' restored to previous delivery plan.'
                        : productTitle + ' upgraded to 90-day delivery.'
                );
            }
        };

        try {
            await (typeof runLineAction === 'function' ? runLineAction(task) : task());
        } catch (error) {
            console.error('Error changing plan upgrade:', error);
            closeWrite();
            releaseLine();
            if (pill) pill.style.removeProperty('display');
            if (typeof window.announceToScreenReader === 'function') {
                window.announceToScreenReader('Error updating delivery plan. Please try again.', 'assertive');
            }
            if (window.FDCartApi) {
                await window.FDCartApi.getCart(true).then(function (cart) {
                    if (typeof updateCartDisplay === 'function') return updateCartDisplay(cart);
                }).catch(function () {});
            }
            if (rejectAction) rejectAction(error);
        }
    }
    window.changePlanUpgrade = changePlanUpgrade;

    function trackNinetyDayCard(action, lines) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'cart_90day_upgrade', action: action, lines: lines });
            if (typeof window.clarity === 'function') window.clarity('event', 'cart_90day_' + action);
        } catch (error) {
            return;
        }
    }

    function isPlanSwitchedLine(item) {
        return String((item && item.properties && item.properties._plan_switcher_from) || '').trim() !== '';
    }

    // The 90-day card's switch: one write per line, the next line looked up in the cart each write returns (keys change).
    async function changeAllPlanUpgrades(action) {
        if (ninetyDayCardBusy) return;
        const startCart = window.FDCart && window.FDCart.getCart();
        if (!startCart || !Array.isArray(startCart.items)) return;
        const isTarget = action === 'undo' ? isNinetyDayCardUpgradedLine : isNinetyDayCardCandidate;
        const keys = startCart.items.filter(isTarget).map(function (item) { return item.key; });
        if (!keys.length) return;

        setNinetyDayCardBusy(true);
        const releases = keys.map(function (key) {
            return holdLine(key, function (article) { markLinePricesPending([article]); });
        });
        const releaseLines = function () {
            releases.splice(0).forEach(function (release) { release(); });
        };
        let writeOpen = true;
        beginCartWrite();
        const closeWrite = function () {
            if (writeOpen) endCartWrite();
            writeOpen = false;
        };
        let moved = 0;

        const task = async function () {
            let cart = window.FDCart.getCart() || await window.FDCartApi.getCart(false);
            const swaps = [];
            for (let step = 0; step < keys.length; step++) {
                let item = null;
                let target = null;
                if (action === 'undo') {
                    item = cart.items.find(isNinetyDayCardUpgradedLine) || null;
                    target = item && {
                        keepCode: cart.items.some(function (other) {
                            return other.key !== item.key && isPlanSwitchedLine(other) && !isNinetyDayCardUpgradedLine(other);
                        })
                    };
                } else {
                    const entry = (await ninetyDayCardPlan(cart)).lines[0];
                    if (entry) {
                        item = entry.item;
                        target = { planId: entry.plan.id, percent: entry.percent };
                    }
                }
                if (!item) break;
                const change = await planUpgradeLineChange(cart, item, action, target);
                cart = await writePlanUpgradeLine(item, action, change, target);
                moved += 1;
                if (change.discountFromCode || change.discountToCode) swaps.push(change);
            }
            for (let i = 0; i < swaps.length; i++) {
                cart = await applyPlanUpgradeDiscountCodes(cart, swaps[i].discountFromCode, swaps[i].discountToCode);
            }
            return cart;
        };

        let cart = null;
        try {
            cart = await runLineAction(task);
        } catch (error) {
            console.error('Error changing 90-day upgrade:', error);
            if (typeof window.announceToScreenReader === 'function') {
                window.announceToScreenReader('Error updating delivery plan. Please try again.', 'assertive');
            }
        }
        closeWrite();
        releaseLines();
        setNinetyDayCardBusy(false);
        if (cart) {
            trackNinetyDayCard(action, moved);
            if (typeof window.announceToScreenReader === 'function') {
                window.announceToScreenReader(
                    action === 'undo'
                        ? 'Subscriptions restored to monthly delivery.'
                        : 'Subscriptions upgraded to 90-day delivery.'
                );
            }
            await updateCartDisplay(cart).catch(function (error) {
                console.error('Mini cart: repaint after 90-day upgrade failed', error);
            });
            return;
        }
        if (window.FDCartApi && typeof window.FDCartApi.getCart === 'function') {
            await window.FDCartApi.getCart(true).then(function (fresh) {
                return updateCartDisplay(fresh);
            }).catch(function () {});
        }
    }
    window.changeAllPlanUpgrades = changeAllPlanUpgrades;

    // Initialize on page load — badge only (lazy full render on drawer open)
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeCart);
    } else {
        initializeCart();
    }
